import { Category } from '@/__generated_graphql__/types';

export const getCategoriesToSubmit = (
  activeTopCategory: Category | null,
  currentlySelectedCategories: Category[] = []
): Category[] => {
  if (!activeTopCategory) return currentlySelectedCategories;

  const subCategoryIds = new Set(
    activeTopCategory.children?.map(child => child.id) ?? []
  );

  const hasSelectedSubcategories = currentlySelectedCategories.some(cat =>
    subCategoryIds.has(cat.id)
  );

  const isTopCategoryAlreadySelected = currentlySelectedCategories.some(
    cat => cat.id === activeTopCategory.id
  );

  if (!hasSelectedSubcategories && !isTopCategoryAlreadySelected) {
    return [...currentlySelectedCategories, activeTopCategory];
  }

  return currentlySelectedCategories;
};
